import { createFileRoute } from '@tanstack/react-router';

import { ContinuityPlanDetailView } from '@/features/bcp/continuity-plans/ContinuityPlanDetailView';

export const Route = createFileRoute('/_authenticated/bcp/plans/$planId/')({
  validateSearch: (search: Record<string, unknown>) => ({
    tab: typeof search.tab === 'string' ? search.tab : undefined,
  }),
  component: ContinuityPlanDetailRoute,
});

function ContinuityPlanDetailRoute() {
  const { planId } = Route.useParams();
  const { tab } = Route.useSearch();

  return <ContinuityPlanDetailView planId={planId} initialTab={tab} />;
}
